import { Box } from '@mui/material'

export const recaptchaVerifierId = 'recaptchaVerifierId'

export const Recaptcha: React.FC = () => (
  <Box id={recaptchaVerifierId} sx={{ position: 'absolute', opacity: 0, pointerEvents: 'none' }} />
)
